import React, { useState , useEffect } from 'react';
import { Row, Col, Container, Input, Card, CardBody, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import Token_Balane from './Token_Balane';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import classnames from "classnames";
import visa from "../../assets/images/visa.png"
import master from "../../assets/images/mastercard.png"
import rupay from "../../assets/images/rupay.png"
import maestro from "../../assets/images/maestro.png"
import { useDispatch , useSelector } from 'react-redux';
import { Add_Payment_Method, Fetch_Payment_Methods, get_billings, get_payment_summary, Get_Plans, group_list, Start_Check_Out } from '../../slices/thunks';
import { convertDate, convertUTCToLocal, convertUTCToLocal_OnlyDate } from '../../slices/layouts/utils';
import Loader from '../../Components/Common/Loader';
import config from '../../config';
import { Package } from 'feather-icons-react/build/IconComponents';
import Pagination from '../../Components/Common/Pagination_Cust';
import Flatpickr from "react-flatpickr";
import Group_Token_Allocation_List from './Group_Token_Allocation_List';
import { update_group_token_allocation_in_bulk } from '../../helpers/fakebackend_helper';
import { open_error_modal } from '../../slices/Error_Modal/reducer';
import { open_success_modal } from '../../slices/Success_Modal/reducer';
import { set_bread_crum } from '../../slices/header/reducer';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../utility/wait_for_confirmation';



const Group_Name_Payment = () => {
// Default Tabs
const [activeTab, setactiveTab] = useState("1");
const [date_filter, setdate_filter] = useState(null)
const [group_token_allocation_list_for_update, set_group_token_allocation_list_for_update] = useState([])
const navigate = useNavigate()
const toggle = (tab) => {
    if (activeTab !== tab) {
        setactiveTab(tab);
    }
};


const dispatch = useDispatch()
const {Last_Bill_Date , Next_Bill_Date , PlanName , Start_Date , SuperUserId  , TokenAllowed , TokenUsed , ValidTill , Plan_Id } = useSelector((state)=> state.Plans.current_plan_details)
const {billings , payment_methods , default_payment_methods , loading , plans , current_plan_type} = useSelector((state)=> state.Plans)
const {groupList} = useSelector((state)=> state.Group_List)
const [remaining_tokens_after_allocation, setremaining_tokens_after_allocation] = useState(0)



useEffect(() => {
    setremaining_tokens_after_allocation(( TokenAllowed)- (groupList?.reduce((sum, group) => {
        return group.User_Role === "Super User" ? sum + group.Token_Allowed : sum;
      }, 0)))


}, [groupList , plans])




useEffect(() => {
    dispatch(get_payment_summary())
    dispatch(get_billings())
    dispatch(Fetch_Payment_Methods())
    dispatch(group_list())
    dispatch(Get_Plans())
    document.title= "Payment"

    // console.log("Working")

}, [])


const [filter, setfilter] = useState({
    page: 1,
    per_page: config.general_config.PER_PAGE_CONTENT,
    sort_by: null,
    sort_order: null,
    search_term:null,
    search_date:null
})


const onClick_Save_Bulk_TokenAllocation_of_group = ()=>{
      
      update_group_token_allocation_in_bulk(group_token_allocation_list_for_update).then(()=>{
        dispatch(open_success_modal("Group Token Allocation Success"))
        dispatch(group_list())
      }).catch(()=>{
        dispatch(open_error_modal("Error While Updating Group Token Allocation"))
      })

}

const onPageChange = (page_number) => {
    let filter_temp = filter
    filter_temp.page=parseInt(page_number)
    setfilter(filter_temp)
    dispatch(get_billings(filter_temp))
  }

const onChange_Search= (e) =>{
    let filter_temp = filter
    filter_temp.search_term=e.target.value
    filter.page = 1
    setfilter(filter_temp)
    dispatch(get_billings(filter_temp))
}

const onChange_Search_Date= (date) =>{
    let filter_temp = filter
    filter_temp.search_date=date
    filter.page = 1
    setfilter(filter_temp)
    dispatch(get_billings(filter_temp))
}

 useEffect(()=>{
    dispatch(set_bread_crum({ title:"Payment Details"  , pageTitle:"Dashboard"  }))

     return ()=>{
     dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
        
     }
   },[])

// next billing date 
const [isDue, setIsDue] = useState(false);

useEffect(() => {
    const today = new Date(); // Current date
    if (new Date(Next_Bill_Date) < today) {
      setIsDue(true);
    }
  }, [Next_Bill_Date]);


  return (
    <React.Fragment>
        <div className="page-content">
        <Container fluid>
            {/* <BreadCrumb title="Payment Detail" pageTitle="Dashboard" />     */}
            <Row className='head_name'>
                <Col lg={12}>
             
                <div className='name_user_plan'>
                    <h2>Hi! {JSON.parse(localStorage.getItem('authUser')).Details.User_Name}
                        {/* <span>
                            <button class="btn btn-outline-primary"> GroupSuperuser </button>
                        </span> */}
                        
                    </h2>
                    <span className='badge custom-badge rounded-pill'> {PlanName}</span> 
                </div>
                </Col>                
            </Row>  
            {/* <Row>
                <Col lg={3}>
                   <Token_Balane TokenAllowed={TokenAllowed-TokenUsed} />
                </Col>
            </Row>  */}
            {/* <Row>
                <Col lg={9}>
                
                </Col>
                <Col lg={3}>
                <div className="input-group">
                    <Input type="text" className="form-control h-40" aria-label="Search group name" placeholder="Search group name"/>
                    <button className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20"></i></button>
                </div>
                    
                </Col> 
            </Row> */}
            <Row className="mt-30">
                <Col>
                <Nav tabs className="nav-tabs mb-3">
                                <NavItem>
                                    <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "1", })} onClick={() => { toggle("1"); }} >
                                        Summary
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "2", })} onClick={() => { toggle("2"); }} >
                                        Billing
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "3", })} onClick={() => { toggle("3"); }} >
                                        Payment Method
                                    </NavLink>
                                </NavItem>
                                {/* <NavItem>
                                    <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "4", })} onClick={() => { toggle("4"); }} >
                                        Settings
                                    </NavLink>
                                </NavItem> */}
                            </Nav>
                    <Card> 
                        <CardBody>
                            
                            { <TabContent activeTab={activeTab} className="text-muted">
                                <TabPane tabId="1" id="home">
                                    <div className='payment_summary'>
                                        <Row>
                                            <Col lg={4}>
                                                <Token_Balane expires={ ValidTill && convertUTCToLocal_OnlyDate(ValidTill)} TokenAllowed={TokenAllowed} TokenRemaining={TokenAllowed-TokenUsed} Next_Bill_Date={Next_Bill_Date && convertUTCToLocal_OnlyDate(Next_Bill_Date)} />
                                                <Card>
                                                   <CardBody>
                                                        <div className=''>
                                                            <p className='text-muted'>Subscription summary</p>
                                                                <ul className='list-group cust-summ'>
                                                                    {/* <li className='list-group-item'><span><b>Token balance</b></span> <span>{TokenAllowed-TokenUsed}</span> </li> */}
                                                                    <li className='list-group-item'><span><b>Current plan</b></span> <span>{PlanName}</span></li> 
                                                                    <li className='list-group-item'><span><b>Token With Plan</b></span> <span>{plans?.filter(plan=> plan.plan_id === Plan_Id)[0]?.FreeTokens.toLocaleString()}</span></li>
                                                                    <li className='list-group-item'><span><b>Top up tokens</b></span> <span>{(TokenAllowed - plans?.filter(plan=> plan.plan_id === Plan_Id)[0]?.FreeTokens).toLocaleString()}</span></li>  
                                                                    <li className='list-group-item nbd'><span><b>Next billing date</b></span> <span>{Next_Bill_Date && convertUTCToLocal_OnlyDate(Next_Bill_Date)}</span><span>{isDue && <button onClick={async (e)=>{
                                                                         dispatch(
                                                                                                                    open_confirm_modal(
                                                                                                                      "Are you sure you want to buy this plan."
                                                                                                                    )
                                                                                                                  );
                                                                                                                  const decision = await waitForDecision();
                                                                                                                  if (decision) {
                                                                                                                    dispatch(
                                                                                                                      Start_Check_Out({
                                                                                                                        plan_id: Plan_Id,
                                                                                                                        plan_type: current_plan_details.Type,
                                                                                                                      })
                                                                                                                    );
                                                                                                                  }
                                                                                                                  dispatch(close_confirm_modal());
                                                                    }} className="btn btn-secondary">Pay Now</button>}</span></li>
                                                                    <li className='list-group-item'><span><b>Last bill date</b></span> <span>{Last_Bill_Date && convertUTCToLocal(Last_Bill_Date)}</span></li>
                                                                    <li className='list-group-item'><span><b>Token expiration</b></span> <span>{ ValidTill && convertUTCToLocal_OnlyDate(ValidTill)}</span></li>
                                                               </ul>
                                                        </div>
                                                   </CardBody>
                                                </Card>
                                            </Col>
                                            <Col lg={8}>
                                            <div className='d-flex cp-inner'>
                                                <div>
                                                <p className='text-muted'>Remaining token after allocation</p>
                                                <h2 style={{ color:remaining_tokens_after_allocation<0? "red":"" }}>{remaining_tokens_after_allocation.toLocaleString()}</h2>
                                                </div>
                                                <Button onClick={onClick_Save_Bulk_TokenAllocation_of_group} className=''>Save</Button>
                                            </div>
                                            
                                            <Card className=''>
                                                <div className='summary_table h-fix2'>
                                                    <table className="table align-middle table-nowrap" id="customerTable">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="sort" data-sort="group_name">Group name</th>
                                                                <th className="sort" data-sort="monthly_limit">Monthly limit</th>
                                                                <th className="sort" data-sort="current_balance">Current balance</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="list">      {
                                                groupList
                                                .filter(group => group.User_Role === "Super User") // Filter for "Super User" role
                                                .map((group, i) => {
                                           
                                                    
                                               
                                              
                                                  return (
                                                    <Group_Token_Allocation_List group={group} group_token_allocation_list_for_update={group_token_allocation_list_for_update} set_group_token_allocation_list_for_update={set_group_token_allocation_list_for_update}  />
                                               
                                                  );
                                                })
                                                            
                                                            
                                                            }                                              
                                                            {/* <tr>
                                                                <td className="group_name">Group A</td>
                                                                <td className="Monthly limit">
                                                                    <Input htmlFor="Monthly limit" placeholder='Monthly limit' style={{textAlign : 'right'}}/>
                                                                </td>
                                                                <td className="edit_view" style={{textAlign : 'right'}}>12,000</td> 
                                                            </tr>   
                                                            <tr>
                                                                <td className="group_name">Group B</td>
                                                                <td className="Monthly limit">
                                                                    <Input htmlFor="Monthly limit" placeholder='Monthly limit' style={{textAlign : 'right'}}/>
                                                                </td>
                                                                <td className="edit_view" style={{textAlign : 'right'}}>12,000</td> 
                                                            </tr>                                                     
                                                            <tr>
                                                                <td className="group_name">Group C</td>
                                                                <td className="Monthly limit">
                                                                    <Input htmlFor="Monthly limit" placeholder='Monthly limit' style={{textAlign : 'right'}}/>
                                                                </td>
                                                                <td className="edit_view" style={{textAlign : 'right'}}>12,000</td> 
                                                            </tr>  */}
                                                        </tbody>
                                                    </table>
                                                    </div>
                                            </Card>
                                            </Col>
                                        </Row>
                                    </div>
                                </TabPane>

                                <TabPane tabId="2" id="product">
                                    <div className='d-flex mb-10'>
                                        <div className='picker'>
                                            <Flatpickr
                                                className="form-control"
                                                
                                                placeholder="Date"
                                                value={date_filter}
                                                onChange={([date]) => {
                                                    onChange_Search_Date(convertDate(date))
                                                    setdate_filter(date)
                                                    }}
                                                options={{
                                                dateFormat: "d M, Y",
                                                maxDate:"today"
                                                }}
                                            />
                                        </div>
                                        <Button size="sm" onClick={()=>{
                                                onChange_Search_Date(null)
                                                setdate_filter(null)
                                        }} >Clear Date</Button>
                                        <div className='search_billing'>
                                        <div className="input-group">
                                            <Input onChange={onChange_Search} value={filter.search_term} type="text" className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" />
                                            <button className="btn btn-secondary" type="button" id="button-addon2"><i className=' ri-search-2-line'></i></button>
                                        </div>
                                    </div>
                                    </div>
                                    { loading?<Loader/>: <div className="listjs-table" id="customerList_group_payment">                                           
                                        <div className="table-responsive mb-1">
                                            <table className="table align-middle table-nowrap" id="customerTable">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Transaction ID</th>
                                                        <th>Invoice ID</th>
                                                        <th className="sort" data-sort="description">Amount</th>
                                                        <th className="sort" data-sort="method">Currency</th>
                                                        <th className="sort" data-sort="method">Token Alloted</th>
                                                        <th className="sort" data-sort="paid_on">Paid on </th>
                                                        <th className="sort" data-sort="paid_on">Payment Type</th>
                                                        <th className="sort" data-sort="status">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {
                                                        billings.data?.map((bills)=>{
                                                            const { AmountPaid ,CreatedAt , PaymentType,PaymentMethod , PaymentStatus , TransactionID , Currency  , InvoiceID , TokenAlloted } = bills

                                                                return <tr>
                                                                <td className="edit_view">{TransactionID}</td>
                                                                <td className="edit_view">{InvoiceID}</td>
                                                                <td className="edit_view">{AmountPaid}</td>
                                                                <td className="edit_view">{Currency}</td>
                                                                <td className="edit_view">{TokenAlloted?.toLocaleString()}</td>
                                                                <td className="edit_view">{CreatedAt}</td>
                                                                <td className="edit_view">{PaymentType==='Instant'? 'monthly-subscription' : PaymentType}</td>
                                                                <td className="status">{PaymentStatus === 'paid' ? 'succeeded' : PaymentStatus }</td>
                                                                </tr>
                                                        })
                                                    }
                                                
                                        
                                                </tbody>
                                            </table>
                                            <div className="noresult" style={{ display: "none" }}>
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                                                        colors="primary:#121331,secondary:#08a88a" style={{ width: "75px", height: "75px" }}>
                                                    </lord-icon>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                    <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any
                                                        orders for you search.</p>
                                                </div>
                                            </div>
                                        </div>
                                    
                                    </div>}
                                    {/* <div className="d-flex justify-content-end">
                                                <div className="pagination-wrap hstack gap-2">
                                                    <Link className="page-item pagination-prev disabled" to="#">
                                                        Previous
                                                    </Link>
                                                    <ul className="pagination listjs-pagination mb-0">
                                                        <li class="page-item">
                                                            <a class="page-link active" href="#">1</a>
                                                        </li>
                                                        <li class="page-item">
                                                            <a class="page-link" href="#">2</a>
                                                        </li>
                                                    </ul>
                                                    <Link className="page-item pagination-next" to="#">
                                                        Next
                                                    </Link>
                                                </div>
                                </div>  */}
                                <Pagination onPageChange={onPageChange} total_pages={billings.total_pages} current_page={billings.current_page} />
                                </TabPane>

                                <TabPane tabId="3" id="payment_method">
                                    <Row>
                                        <Col lg={12}>
                                            {payment_methods.length > 0 && <div className='add-pay-method'>
                                                <Button onClick={()=>
                                                dispatch(Add_Payment_Method())
                                                } color='secondary'>Manage Payment Method </Button>
                                            </div>}
                                        </Col>
                                    </Row>
                                    <Row className="row-cols-xxl-5 row-cols-lg-3 row-cols-1">
                                        {
                                            payment_methods.map((payment_method)=>{
                                                const { brand ,  exp_month , exp_year , last4 , id , is_default} = payment_method
                                                let img_data
                                                            if( brand === 'visa'){
                                                                img_data = visa
                                                            }else if( brand === 'rupay'){
                                                                img_data = rupay
                                                            }else if( brand === 'master'){
                                                                img_data = master
                                                            }else if( brand ==='maestro'){
                                                                img_data= maestro
                                                            }
                                                            
                                                return <Col>
                                                <Card className="card-body">
                                                    <div className="d-flex mb-4 align-items-center">
                                                        <div className="flex-shrink-0">
                                                            <img src={img_data} alt="" className="avatar-sm" />
                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <h5 className="card-title card-number mb-1">{`xxxx xxxx xxxx ${last4}`}</h5>
                                                            <p className="text-muted mb-0">Expires <span>{{exp_month}/{exp_year}}</span></p>
                                                        </div>
                                                    </div>
                                                    <div className='set_dell'>
                                                        
                                                        {is_default ?<span>Default</span> : 
                                                        // <Button className=" btn-sm" color='secondary'>Set as Default</Button>
                                                        ''}
                                                        
                                                        
                                                    </div>
                                                </Card>
                                            </Col>
                                            })
                                        }
                                    
                                    </Row>
                                </TabPane>

                                {/* <TabPane tabId="4" id="settings">
                                    <h6>Settings</h6>
                                    <p className="mb-0">
                                        Trust fund seitan letterpress, keytar raw denim keffiyeh etsy
                                        art party before they sold out master cleanse gluten-free squid
                                        scenester freegan cosby sweater. Fanny pack portland seitan DIY,
                                        art party locavore wolf cliche high life echo park Austin. Cred
                                        vinyl keffiyeh DIY salvia PBR, banh mi before they sold out
                                        farm-to-table VHS.
                                    </p>
                                </TabPane> */}
                            </TabContent>}
                        </CardBody>
                        {/* <CardBody>
                            <div className="listjs-table" id="customerList_group_payment">
                                <div className="table-responsive table-card mb-1">
                                    <table className="table align-middle table-nowrap" id="customerTable">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Purchase ID</th>
                                                <th className="sort" data-sort="description">Description</th>
                                                <th className="sort" data-sort="method">Method</th>
                                                <th className="sort" data-sort="paid_on">Paid on </th>
                                                <th className="sort" data-sort="status">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="list">
                                            <tr>
                                                <td className="edit_view">OEIrwoeioi12342</td>
                                                <td className="description">OEIrwoeioi12342</td>
                                                <td className="method">Visa-2344</td>
                                                <td className="">yyyy-mm-dd</td>                                               
                                                <td className="status">Completed</td>
                                            </tr>  
                                            <tr>
                                            <td className="edit_view">OEIrwoeioi12342</td>
                                                <td className="description">OEIrwoeioi12342</td>
                                                <td className="method">Visa-2344</td>
                                                <td className="paid_on">yyyy-mm-dd</td>  
                                                <td className="status"><Button color="danger" outline > Fail </Button></td>


                                            </tr>                                                  
                                        </tbody>
                                    </table>
                                    <div className="noresult" style={{ display: "none" }}>
                                        <div className="text-center">
                                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                                                colors="primary:#121331,secondary:#08a88a" style={{ width: "75px", height: "75px" }}>
                                            </lord-icon>
                                            <h5 className="mt-2">Sorry! No Result Found</h5>
                                            <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any
                                                orders for you search.</p>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </CardBody>
                    </Card>
                    <div className="d-flex justify-content-end">
                                    <div className="pagination-wrap hstack gap-2">
                                        <Link className="page-item pagination-prev disabled" to="#">
                                            Previous
                                        </Link>
                                        <ul className="pagination listjs-pagination mb-0">
                                            <li class="page-item">
                                                <a class="page-link active" href="#">1</a>
                                            </li>
                                            <li class="page-item">
                                                <a class="page-link" href="#">2</a>
                                            </li>
                                        </ul>
                                        <Link className="page-item pagination-next" to="#">
                                            Next
                                        </Link>
                                    </div>
                    </div> */}
                    </Card>
                    
                </Col>
            </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Group_Name_Payment
